import { useRef, useEffect } from "react";
// Хук предназначен для запоминания значения функционального компонента, вычисленного во время предыдущего рендеринга.
export var usePrevious = function (value) {
    var ref = useRef();
    useEffect(function () {
        ref.current = value;
    }, [value]);
    return ref.current;
};
